<template>
  <article
    v-if="garageBrands"
    class="garage-brands"
  >

    <h2 class="garage-brands__header">Marki samochodów naprawiane przez warsztat</h2>
    <ul class="garage-brands__brands">
      <li
        v-for="garageBrand in garageBrands"
        :key="garageBrand.id"
        class="garage-brands__brand"
      >
        <a :href="`https://dobrymechanik.pl/specjalizacje/${garageBrand.brandSpecialization?.slug}/${city}/`">
          <span>{{ garageBrand.brandSpecialization?.name }}</span>
        </a>
      </li>
    </ul>
  </article>
</template>

<script
  setup
  lang="ts"
>
import type { GarageBrandSpecializationJsonldBrandSpecializationReadSpecializationRead } from '~/api/docs/api';


interface IProps {
  garageBrands: GarageBrandSpecializationJsonldBrandSpecializationReadSpecializationRead[];
}

const props = defineProps<IProps>();

// use
const route = useRoute();

// computed
const city = computed(() => {
  return route.params['city'] as string;
});
</script>

<style
  lang="scss"
  scoped
>
@import url('assets/styles/components/garage-brands.scss');
</style>